export default __webpack_public_path__ + "static/card-image-6-931efc3d1ae91a39aec0204997899728.jpg";